(function (angular) {
    'use strict';

    angular
        .module('app.sitemap', []);
        
})(angular);
